import { Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { SecurityEvents } from "../components/SecurityEvents.tsx";

/** The whole security event log (bd-2av.2), including events not tied to a user such as password reset requests. Requires audit.read. */
export function SecurityEventsPage() {
  const { t } = useTranslation();
  return (
    <Space orientation="vertical" size="middle" style={{ width: "100%" }}>
      <div>
        <Typography.Title level={3} style={{ margin: 0 }}>
          {t("audit.security.title")}
        </Typography.Title>
        <Typography.Text type="secondary">{t("audit.security.subtitle")}</Typography.Text>
      </div>
      <SecurityEvents />
    </Space>
  );
}
